<template>
    <div class="container-fechamento">       

        <c-panel>

            <div class="u-mb-10">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-breadcrumb v-if="!usaConceito" separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :class="{ active: turma.fase_diario >= 2  }">Conselho Pacial</el-breadcrumb-item>
                            <el-breadcrumb-item :class="{ active: turma.fase_diario >= 3  }">Conselho Pacial Encerrado</el-breadcrumb-item>
                            <el-breadcrumb-item :class="{ active: turma.fase_diario >= 4  }">Conselho Final</el-breadcrumb-item>
                            <el-breadcrumb-item :class="{ active: turma.fase_diario == 5  }">Fechado</el-breadcrumb-item>
                        </el-breadcrumb>
                        <el-breadcrumb v-else separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :class="{ active: turma.fase_diario >= 4  }">Conselho Final</el-breadcrumb-item>
                            <el-breadcrumb-item :class="{ active: turma.fase_diario == 5  }">Fechado</el-breadcrumb-item>
                        </el-breadcrumb>
                    </el-col>
                </el-row>
            </div>
            
            <div class="">                
                <template>

                    <table class="table table-striped" v-if="$route.params.id && turma.metodo_avaliacao == 'quantitativo' && metodoCarregado && !usaConceito">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th class="u-text-center">Faltas</th>
                                <th v-for="(disciplina, j) in disciplinas" :key="j" class="u-text-center">{{ disciplina }}</th>
                                <th class="u-text-center">Sit. Academica</th>
                                <th class="u-text-center" style="width: 80px;">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading">
                            <tr v-for="(item, i) in alunos" :key="item.id">
                                <td>
                                    <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                        <b class="hidden-desktop">NOME:</b> {{ item.aluno.nome_social_aluno ? item.aluno.nome + ' – ' + item.aluno.nome_social_aluno : item.aluno.nome }}<br>
                                    </a>
                                    <span v-if="item.aluno.data_nascimento" class="nm-mae">Dt. Nascimento: {{ $moment(item.aluno.data_nascimento).format('DD/MM/YYYY') }}</span><br>
                                    <span v-if="item.aluno.mae" class="nm-mae">Filiação 1: {{ item.aluno.mae.toLowerCase() }}</span>
                                    
                                </td>
                                <td class="u-text-center">
                                    <span v-if="item.frequencia_total_faltas">{{ item.frequencia_total_faltas }} / {{ item.frequencia_total_lancamentos }}</span>
                                    <span v-else>-</span>
                                </td>

                                <td v-for="(disciplina, j) in disciplinas" :key="j" class="u-text-center" 
                                    :class="{ 
                                        conservado: (item.notas && item.notas.atividades[j] && item.notas.atividades[j]['m_final'] && item.notas.atividades[j]['m_final']['v'] && convertFloat(item.notas.atividades[j]['m_final']['v']) < $CONSTANTS.MEDIA && !item.notas.atividades[j]['m_final']['flag']),
                                        aprovado: ((item.notas && item.notas.atividades[j] && item.notas.atividades[j]['m_final'] && item.notas.atividades[j]['m_final']['v'] && convertFloat(item.notas.atividades[j]['m_final']['v']) >= $CONSTANTS.MEDIA) || (item.notas && item.notas.atividades[j] && item.notas.atividades[j]['m_final']['flag']))
                                    }" 
                                >
                                    <span v-if="item.notas && item.notas.atividades[j] && item.notas.atividades[j]['r'] && item.notas.atividades[j]['r']['v'] && !item.notas.atividades[j]['m_final']['flag']">
                                        <span style="text-decoration: line-through;">{{ item.notas.atividades[j]['m_parcial']['v'] !== '' ? item.notas.atividades[j]['m_parcial']['v'] : 'SN'  }}</span><br>
                                        {{ item.notas.atividades[j]['r']['v']  }}
                                    </span>
                                    <span v-else>
                                        {{ item.notas && item.notas.atividades[j] && item.notas.atividades[j]['m_final'] && item.notas.atividades[j]['m_final']['v'] ? item.notas.atividades[j]['m_final']['v'] : '' }}
                                    </span>
                                    <br>
                                    <span v-if="item.notas && item.notas.atividades[j] && item.notas.atividades[j]['m_final'] && item.notas.atividades[j]['m_final']['flag']" :title="$CONSTANTS.FLAGS_DIARIO[item.notas.atividades[j]['m_final']['flag']]" class="flag-diario">
                                        {{ item.notas.atividades[j]['m_final']['flag'] }}
                                    </span>
                                </td>
                                <td :class="{ 
                                    aprovado: getSituacaoAcademica(item.situacao_academica_parcial) == 'APROVADO',
                                    conservado: getSituacaoAcademica(item.situacao_academica_parcial) == 'CONSERVADO'
                                }" class="u-text-center">
                                    {{ item.situacao_academica_parcial }} 
                                </td>
                                <td class="acao"> 

                                    <div style="display: flex; justify-content: center;">

                                        <el-button v-if="turma.fase_diario != 2 && turma.fase_diario != 4 && turma.fase_diario != 5" disabled type="info" icon="el-icon-menu" size="mini" plain></el-button>

                                        <el-popover class="u-ml-10" placement="left" v-if="turma.fase_diario == 2 || turma.fase_diario == 4 || turma.fase_diario == 5">
                                            <ul class="list-acoes">
                                                
                                                <li @click="openDialogFrequencia(item)">
                                                    <i class="far fa-calendar-alt"></i>
                                                    Visualizar Frequência
                                                </li>
                                                <li @click="openDialogNota(item.aluno)">
                                                    <i class="fas fa-calculator"></i>
                                                    Visualizar Notas
                                                </li>
                                                <!-- <hr /> -->
                                                <li @click="abreModalAprovarPeloConselho(item)" v-if="verificaRegrasConselho(item) && $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Aprovar pelo Conselho
                                                </li>
                                                <li @click="removerAprovacaoPeloConselho(item)" v-if="turma.fase_diario != 5 && 
                                                                                                      item.situacao_academica_parcial.includes('APROVADO PELO CONSELHO') &&
                                                                                                      $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Remover Aprovação pelo Conselho
                                                </li>
                                                <li @click="openReconsiderarFaltas(item)" v-if="(item.situacao_academica_parcial == 'CONSERVADO POR FALTA' || item.faltas_reconsideradas) && $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Reconsiderar faltas
                                                </li>
                                            </ul>
                                            <el-button slot="reference" title="Mais ações"  icon="el-icon-menu" size="small" type="primary" plain></el-button>
                                        </el-popover>
                                                                                        
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-striped" v-if="$route.params.id && turma.metodo_avaliacao == 'qualitativo'">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th class="u-text-center">Faltas</th>
                                <th v-for="(periodo, j) in turma.periodos_diario" :key="j" class="u-text-center">{{ periodo }}</th>
                                <th class="u-text-center">Sit. Academica</th>
                                <th class="u-text-center" style="width: 80px;">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading">
                            <tr v-for="(item, i) in alunos" :key="item.id">
                                <td>
                                    <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                        <b class="hidden-desktop">NOME:</b> {{ item.aluno.nome_social_aluno ? item.aluno.nome + ' – ' + item.aluno.nome_social_aluno : item.aluno.nome }}<br>
                                    </a>
                                    <span v-if="item.aluno.data_nascimento" class="nm-mae">Dt. Nascimento: {{ $moment(item.aluno.data_nascimento).format('DD/MM/YYYY') }}</span><br>
                                    <span v-if="item.aluno.mae" class="nm-mae">Filiação 1: {{ item.aluno.mae.toLowerCase() }}</span>
                                    
                                </td>
                                <td class="u-text-center">
                                    <span v-if="item.frequencia_total_faltas">{{ item.frequencia_total_faltas }}  / {{ item.frequencia_total_lancamentos }}</span>
                                    <span v-else>-</span>
                                </td>                                
                                <td v-for="(periodo, p) in turma.periodos_diario" :key="p" class="u-text-center">
                                    
                                    <img v-if="item.parecer && item.parecer[p + 1]" src="@/assets/img/d-ok.png" />
                                    <img v-if="item.parecer && !item.parecer[p + 1]" src="@/assets/img/d-pedding.png" />
                                    <span v-if="!item.parecer">-</span>

                                </td>
                                <td :class="{ 
                                    aprovado: getSituacaoAcademica(item.situacao_academica_parcial) == 'APROVADO',
                                    conservado: getSituacaoAcademica(item.situacao_academica_parcial) == 'CONSERVADO'
                                }" class="u-text-center">

                                    <!-- QUANDO FOR TURMA AEE -->
                                    <span v-if="turma.tipo_ensino == 3">
                                        {{ item.situacao_academica_parcial.includes('APROVADO') ? 'CONCLUÍDO' : item.situacao_academica_parcial }}
                                    </span>
                                    <span v-else>
                                        {{ item.situacao_academica_parcial }} 
                                    </span>
                                </td>
                                
                                <td class="acao"> 

                                    <div style="display: flex; justify-content: center;">
                                        
                                        <el-popover placement="left">
                                            <ul class="list-acoes">
                                                
                                                <li @click="openDialogFrequencia(item)">
                                                    <i class="far fa-calendar-alt"></i>
                                                    Visualizar Frequência
                                                </li>
                                                <li @click="openDialogNota(item.aluno)">
                                                    <i class="fas fa-calculator"></i>
                                                    Visualizar Pareceres
                                                </li>
                                                <li @click="openReconsiderarFaltas(item)" v-if="item.situacao_academica_parcial == 'CONSERVADO POR FALTA' && $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Reconsiderar faltas
                                                </li>
                                            </ul>
                                            <el-button slot="reference" title="Mais ações"  icon="el-icon-menu" size="small" type="primary" plain></el-button>
                                        </el-popover>
                                                                                        
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Fechamento por CONCEITO (sem colunas de disciplina; detalhe no botão Visualizar Notas) -->
                    <table class="table table-striped" v-if="$route.params.id && usaConceito">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th class="u-text-center">Faltas</th>
                                <th class="u-text-center">Sit. Academica</th>
                                <th class="u-text-center" style="width: 80px;">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading">
                            <tr v-for="(item, i) in alunos" :key="item.id">
                                <td>
                                    <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                        <b class="hidden-desktop">NOME:</b> {{ item.aluno.nome_social_aluno ? item.aluno.nome + ' – ' + item.aluno.nome_social_aluno : item.aluno.nome }}<br>
                                    </a>
                                    <span v-if="item.aluno.data_nascimento" class="nm-mae">Dt. Nascimento: {{ $moment(item.aluno.data_nascimento).format('DD/MM/YYYY') }}</span><br>
                                    <span v-if="item.aluno.mae" class="nm-mae">Filiação 1: {{ item.aluno.mae.toLowerCase() }}</span>
                                </td>
                                <td class="u-text-center">
                                    <span v-if="item.frequencia_total_faltas">{{ item.frequencia_total_faltas }} / {{ item.frequencia_total_lancamentos }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td :class="{
                                    aprovado: getSituacaoAcademica(situacaoConceitoAluno(item.aluno.id).situacao) == 'APROVADO',
                                    conservado: getSituacaoAcademica(situacaoConceitoAluno(item.aluno.id).situacao) == 'CONSERVADO'
                                }" class="u-text-center">
                                    {{ situacaoConceitoAluno(item.aluno.id).situacao || 'INDEFINIDO' }}
                                </td>
                                <td class="acao">
                                    <div style="display: flex; justify-content: center;">
                                        <el-button v-if="turma.fase_diario != 4 && turma.fase_diario != 5" disabled type="info" icon="el-icon-menu" size="mini" plain></el-button>
                                        <el-popover class="u-ml-10" placement="left" v-if="turma.fase_diario == 4 || turma.fase_diario == 5">
                                            <ul class="list-acoes">
                                                <li @click="openDialogFrequencia(item)">
                                                    <i class="far fa-calendar-alt"></i>
                                                    Visualizar Frequência
                                                </li>
                                                <li @click="openDialogNota(item.aluno)">
                                                    <i class="fas fa-calculator"></i>
                                                    Visualizar Notas
                                                </li>
                                                <li @click="aprovarPeloConselhoConceito(item)" v-if="turma.fase_diario == 4 && (situacaoConceitoAluno(item.aluno.id).conservado || situacaoConceitoAluno(item.aluno.id).situacao === '') && !situacaoConceitoAluno(item.aluno.id).aprovado_conselho && $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Aprovar pelo Conselho
                                                </li>
                                                <li @click="removerAprovacaoPeloConselho(item)" v-if="turma.fase_diario != 5 && situacaoConceitoAluno(item.aluno.id).aprovado_conselho && $store.state.user.tipo != 7">
                                                    <i class="fas fa-arrow-circle-up"></i>
                                                    Remover Aprovação pelo Conselho
                                                </li>
                                            </ul>
                                            <el-button slot="reference" title="Mais ações" icon="el-icon-menu" size="small" type="primary" plain></el-button>
                                        </el-popover>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="u-mt-5" v-if="!loading && !usaConceito">
                        <template v-for="(value, i) in $CONSTANTS.FLAGS_DIARIO">
                            {{ `${i} - ${value};` }}
                        </template>
                    </div>

                    <div v-if="!$route.params.id" class="u-text-center">
                        <i>Selecione uma turma</i>
                    </div>

                    <div v-if="loading" class="u-text-center u-mt-25">
                        <img src="/public/img/loading-bar.gif" />
                    </div>

                </template>
            </div>
        </c-panel>
        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected.aluno.id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :title="alunoSelected ? `${ alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome } - ${$moment(alunoSelected.data_nascimento).format('DD/MM/YYYY')}` : ''" :visible.sync="dialogFrequencia">
            <div v-if="dialogFrequencia" style="margin-top: 20px;">
                <frequencia :turma_id="$route.params.id" :aluno_id="alunoSelected.id" :tipo_ensino="alunoSelected.tipo_ensino" :mostra_gerenciar_freq="true" @close="closeDialogFrequencia"></frequencia>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="1vh" :title="alunoSelected ? `${alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome } - ${$moment(alunoSelected.data_nascimento).format('DD/MM/YYYY')}` : ''" :visible.sync="dialogNota">
            <div v-if="dialogNota" style="margin-top: 20px;">
                <nota :turma_id="$route.params.id" :aluno_id="alunoSelected.id" :mostra_gerenciar_nota="true" @close="closeDialogNota"></nota>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="PARECER" width="60%" :visible.sync="dialogAprovarConselho" v-on:close="closeDialogAprovarConselho">
            <div v-if="dialogAprovarConselho" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitAprovarPeloConselho()" :model="aprovarConselho" ref="aprovarConselho" label-position="top">
                    <el-row :gutter="10">                    
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observação (opcional)" prop="observacao" key="observacao">
                                <el-input :rows="5" type="textarea" v-model="aprovarConselho.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10"> 
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                            <el-button type="primary" native-type="submit">APROVAR PELO CONSELHO</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="RECONSIDERAR FALTAS" width="60%" :visible.sync="dialogReconsiderarFaltas" v-on:close="closeDialogReconsiderarFaltas">
            <div v-if="dialogReconsiderarFaltas" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitReconsiderarFaltas()" :model="reconsiderarFaltas" ref="reconsiderarFaltas" label-position="top">
                    <el-row :gutter="10">                    
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Quantidade" prop="qtd" key="qtd" :rules="[$requiredBlur]">
                                <el-input v-mask="'#########'" v-model="reconsiderarFaltas.qtd"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">                    
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observação" prop="observacao" key="observacao" :rules="[$requiredBlur]">
                                <el-input :rows="5" type="textarea" v-model="reconsiderarFaltas.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10"> 
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                            <el-button type="primary" native-type="submit">RECONSIDERAR FALTAS</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                
            </div>
        </el-dialog>

    </div>
</template>
<script>

import dossieAluno from '@/components/aluno/dossie'
import frequencia from '@/components/diario/frequencia/info'
import nota from '@/components/diario/nota/info'
import conteudo from '@/components/diario/conteudo/info'

export default {
    data: () => ({
        loading: true,
        itemSelecionado: {},
        dialogAprovarConselho: false,
        dialogAlterarData: false,
        aprovarConselho: {
            observacao: ''
        },
        alteraData: {
            turma_id: '',
            aluno_nome: '',
            aluno_id: '',
            data: '',
            tipo: ''
        },
        matriculaSelected: {},
        dialogReconsiderarFaltas: false,
        reconsiderarFaltas: {
            qtd: '',
            observacao: ''
        },
        dialogDossieAluno: false,
        dialogFrequencia: false,
        dialogNota: false,
        dialogConteudo: false,
        alunoSelected: {},
        turmas: [],
        alunos: [],
        disciplinas: [],
        turma: {},
        metodoAvaliacaoGlobal: 'quantitativo',
        metodoCarregado: false,
        situacoesConceito: {}
    }),
    computed: {
        // Turma opera por conceito: método global conceito e turma não qualitativa
        usaConceito () {
            return this.metodoAvaliacaoGlobal === 'conceito' && this.turma && this.turma.metodo_avaliacao !== 'qualitativo';
        }
    },
    mounted () {

        this.carregarMetodo();
        this.loadingAlunos();
    },
    methods: {
        carregarMetodo(){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/avaliacao.metodo`, this.$store.getters.getHeaderAuth)
                .then(r => { this.metodoAvaliacaoGlobal = (r.data && r.data.valor) ? r.data.valor : 'quantitativo'; this.metodoCarregado = true; })
                .catch(() => { this.metodoAvaliacaoGlobal = 'quantitativo'; this.metodoCarregado = true; });
        },
        carregarFechamentoConceito(){
            this.situacoesConceito = {};
            if(!this.turma || !this.turma.id || this.turma.metodo_avaliacao === 'qualitativo') return;
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/avaliacao-conceito-aluno/getFechamento/${this.turma.id}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.situacoesConceito = (r.data && r.data.situacoes) ? r.data.situacoes : {}; })
                .catch(() => { this.situacoesConceito = {}; });
        },
        situacaoConceitoAluno(alunoId){
            return this.situacoesConceito[alunoId] || { situacao: '', conservado: false, aprovado_conselho: false };
        },
        aprovarPeloConselhoConceito(item){
            this.$msgbox.confirm(`Tem certeza que deseja aprovar ${item.aluno ? item.aluno.nome : ''} pelo Conselho de Classe Final?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true);
                let payload = { aluno_id: item.aluno.id, turma_id: this.turma.id, observacao: '' };
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/aprovarPeloConselhoConceitoFinal`, payload, this.$store.getters.getHeaderAuth).then(response => {
                    if(typeof response.data.erro !== 'undefined'){
                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK', type: 'warning' }).catch(()=>{});
                    }else{
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingAlunos();
                    }
                    window.eventBus.$emit('loading', false);
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }).catch(()=>{});
        },
        openReconsiderarFaltas(item){

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getReconsiderarFaltas/${item.aluno_id}/${this.turma.id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.faltas_reconsideradas_qtd > 0) {
                    
                    this.reconsiderarFaltas.qtd = response.data.faltas_reconsideradas_qtd;
                    this.reconsiderarFaltas.observacao = response.data.faltas_reconsideradas_obs;
                }

                this.dialogReconsiderarFaltas = true;
                this.alunoSelected = item;
                
                this.loading = false;
                
            }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });
            
        },
        closeDialogReconsiderarFaltas(){

            this.alunoSelected = {  };
            this.dialogReconsiderarFaltas = false;
            this.reconsiderarFaltas = {
                qtd: '',
                observacao: ''
            }
        },
        onSubmitReconsiderarFaltas(item) {

            this.$refs.reconsiderarFaltas.validate((valid) =>{ if(valid){

                this.$msgbox.confirm(`Tem certeza que deseja reconsiderar ${this.reconsiderarFaltas.qtd} faltas do aluno(a) ${this.alunoSelected.nome_aluno}?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                    window.eventBus.$emit('loading', true);

                    let payload = {
                        aluno_id: this.alunoSelected.aluno_id,
                        turma_id: this.turma.id,
                        qtd: this.reconsiderarFaltas.qtd,
                        observacao: this.reconsiderarFaltas.observacao
                    };

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/reconsiderarFaltas`, payload, this.$store.getters.getHeaderAuth).then(response => {
                                                
                        if(typeof response.data.erro !== 'undefined'){

                            this.$alert(response.data.erro, 'Atenção', {
                                confirmButtonText: 'OK',
                                type: 'warning'
                            }).catch(()=>{});

                        }else{
                            
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.loadingAlunos();
                            this.alunoSelected = {};
                            this.dialogReconsiderarFaltas = false;
                        }

                        window.eventBus.$emit('loading', false);

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }).catch(()=>{});

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        loadingAlunos(){

            this.alunos = [];

            if(!this.$route.params.id) {
                return;
            }

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForFechamento/${this.$route.params.id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.alunos = response.data.alunos;
                this.disciplinas = response.data.disciplinas;
                this.turma = response.data.turma;

                this.carregarFechamentoConceito();

                this.loading = false;

            }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });
        },
        verificaRegrasConselho(item) {
            
            if(this.turma.fase_diario == 5) {
                return false;
            }

            if(this.getSituacaoAcademica(item.situacao_academica_parcial) != 'CONSERVADO') {
                return false;
            }

            if(item.situacao_academica_parcial == 'CONSERVADO POR FALTA') {
                return false;            
            }

            if(this.turma.fase_diario == 2) {
                return true;
            }

            let disciplinas_nao_verificadas = [
                6,  //HISTÓRIA E CULTURA AFRO
                14, //EDUCACAO AMBIENTAL
                7   //TECNICAS AGRICOLAS
            ];

            let qtdReprovacoes = 0;
            if(item.notas){
                for(let i in item.notas.atividades) {
                    let nota = this.convertFloat(item.notas.atividades[i].m_final.v);
                    if(!disciplinas_nao_verificadas.includes(parseInt(i)) && nota < this.$CONSTANTS.MEDIA) {
                        qtdReprovacoes++;
                    }
                }
            }            

            if(qtdReprovacoes > 2) {
                return false;
            }

            return true;

        },
        closeDialogAprovarConselho() {
            this.itemSelecionado = {};
            this.aprovarConselho.observacao = '';
            this.dialogAprovarConselho = false;
        },
        async abreModalAprovarPeloConselho(item) { 

            this.itemSelecionado = item;
            this.dialogAprovarConselho = true;
        },
        async onSubmitAprovarPeloConselho() {            

            this.$msgbox.confirm(`Tem certeza que deseja aprovar ${this.itemSelecionado.nome_aluno} pelo Conselho de Classe?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                 
                let payload = {
                    aluno_id: this.itemSelecionado.aluno_id,
                    turma_id: this.turma.id,
                    observacao: this.aprovarConselho.observacao
                };

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/aprovarPeloConselho`, payload, this.$store.getters.getHeaderAuth).then(response => {
                    
                    this.dialogAprovarConselho = false;

                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', {
                            confirmButtonText: 'OK',
                            type: 'warning'
                        }).catch(()=>{});

                    }else{
                        
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingAlunos();
                    }

                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        async removerAprovacaoPeloConselho(item) {

            this.$msgbox.confirm(`Tem certeza que deseja remover a aprovação pelo conselho de ${item.nome_aluno}?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                 
                let payload = {
                    aluno_id: item.aluno_id,
                    turma_id: this.turma.id                    
                };

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/removerAprovacaoPeloConselho`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingAlunos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        openDossieAluno(item){

            this.dialogDossieAluno = true;
            this.alunoSelected = item;
        },
        closeDialogDossieAluno(){

            this.alunoSelected = {  };
            this.dialogDossieAluno = false;
        },
        openDialogFrequencia(item){
            this.alunoSelected = { tipo_ensino: item.tipo_ensino, ...item.aluno };
            this.dialogFrequencia = true;   
        },
        closeDialogFrequencia(){

            this.loadingAlunos();
            this.dialogFrequencia = false;
        },
        openDialogNota(item){
            this.alunoSelected = item;
            this.dialogNota = true;
        },        
        closeDialogNota(){

            this.loadingAlunos();
            this.dialogNota = false;
        },
        changeDossie(actions){

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
        getSituacaoAcademica(situacao) {
            
            if(situacao.includes("APROVADO")) {
                return 'APROVADO';
            }

            if(situacao.includes("CONSERVADO")) {
                return 'CONSERVADO';
            }

        },
        convertFloat(v) {
            if (v === "" || v === null || v === undefined) return 0;
            return parseFloat(v.toString().replace(",", "."));
        }
    },

    components:{ dossieAluno, frequencia, nota, conteudo }
}
</script>
<style>
    .container-diario .level {
        
        border-radius: 30px !important;
        border: 2px solid #b1b1b1;

    }
    .container-diario .info {
        
        width: 100% !important;
        text-align: center !important;
    }

    .container-diario .info img {
        max-width: 200px;
    }

    .icon-edit-data {
        color: #999999;
        margin-left: 5px;
    }

    .aprovado {
        background-color: #e3fde3;
    }

    .conservado {
        background-color: #ffecec;
    }

    .ap-conselho {
        background-color: rgb(255, 255, 153);
    }

    .active .el-breadcrumb__inner {
        font-weight: bold;
        color: #383838;
    }

    .flag-diario {
        border: 1px solid #8d8d8d;
        border-radius: 5px;
        padding: 2px;
        font-size: 11px;
        color: #8d8d8d;
    }

</style>